import React from "react";
import styled from "styled-components";

import {getConfig} from "../../../../../utils/config"

const config = getConfig();

const colors = config.theme.colors;

const Button = styled.button`
  top: 0px;
  left: 10px;
  z-index: 1001;
  background-color: transparent !important;
  border: none;
  color: ${colors.primary};
  font-size: 14px;
  font-weight: bold;
  border-radius: 20px;
  padding: 8px 15px;
  text-transform: uppercase;
  cursor: pointer;
  max-height: 40px;
  display: none;

  @media (max-width: 768px) {
    display: ${(props) => (props.hidden ? "none" : "block")};
  }

  &:hover {
    background-color: #29b6f6;
    box-shadow: 0 3px 0 #0288d1;
  }

  &:active {
    box-shadow: 0 1px 0 #0277bd;
    transform: translateY(2px);
  }
`;

const HamburgerButton = ({ setMenuOpen, menuOpen }) => {
  return (
    <Button hidden={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
      <i className="fas fa-bars"></i>
    </Button>
  );
}
export default HamburgerButton;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/HamburgerButton/index.jsx